export class ChangePasswordModel {
    public id: number;
    public currentPassword: string;
    public newPassword: string;
    public confirmPassword: string;
}